import { render } from "./division-list.vue?vue&type=template&id=7d6e35cb"
import script from "./division-list.vue?vue&type=script&lang=js"
export * from "./division-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__